export function Button({ color, onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{ backgroundColor: color }}
      className={`w-auto hover:bg-blue-700 focus:ring-blue-500 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base text-white font-medium focus:outline-none focus:ring-2 focus:ring-offset-2`}
    >
      {children}
    </button>
  );
}
